import React from 'react';

import { Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

import { useIsVideoFirstArm } from '#src/app/pages/actions/shared/hooks';

import { useVideosComponentContext } from '../../context';
import { ErrorMessage } from '../ErrorMessage';

import { Upload } from './components/Upload';
import { VideoPlayer } from './components/VideoPlayer';

export const VideoUpload: React.FC = () => {
	const {
		data: { errorMessage },
	} = useVideosComponentContext();
	const isVideoFirstArm = useIsVideoFirstArm();

	return (
		<>
			<div className="text-center">
				{/* The design sets this a step down from production's, at 24px. */}
				<Text
					as="h2"
					variant="heading"
					size={isVideoFirstArm ? 'small' : 'large'}
					fontWeight="bold"
					className="text-typography-strong"
				>
					<Translate value="corgi.petition_actions.supporter_voice_video.submit.heading" />
				</Text>
			</div>

			{errorMessage && <ErrorMessage />}

			<VideoPlayer />
			<Upload />
		</>
	);
};
